export const getAddressFromGeoData = (geoData) =>
  geoData.response.GeoObjectCollection.metaDataProperty.GeocoderResponseMetaData.request;
